import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import { TextInput } from "../../../../../common/form";

const SurplusAllocationTable = (props) => {
  return (
    <div className="type-table">
      <div className="row table-header">
        <div className="cell">
          <h5>{<FormattedMessage id={`clientCoverages.form.markUpRate`} />}</h5>
        </div>

        <div className="cell">
          <h5>
            {<FormattedMessage id={`clientCoverages.form.clientReserveRate`} />}
          </h5>
        </div>
      </div>
      <div className="row rate-fixed-type">
        <div className="cell pourcent">
          <Field
            id="markUpRate"
            name="markUpRate"
            component={TextInput}
            type="absNumber"
            onBlur={props.onChangeRate.bind(null, "markUpRate")}
            readOnly={props.readOnly||props.isArchived}
          />
        </div>
        <div className="cell pourcent">
          <Field
            id="clientReserveRate"
            name="clientReserveRate"
            component={TextInput}
            type="absNumber"
            readOnly="readonly"
            disabled={props.isArchived}
          />
        </div>
      </div>
    </div>
  );
};

SurplusAllocationTable.propTypes = {
  onChangeRate: PropTypes.func,
  isArchived: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default SurplusAllocationTable;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/SurplusAllocationTable.js